import React from 'react';

export default ({handleSortClick, order, sortedBy}) => {
  function createClasses(key) {
    if (sortedBy === key) return `${order ? 'asc' : 'desc'} active`;
    return '';
  }

  return (
    <div className='list-scene__table-header'>
      <div
        className={`list-scene__table-header-element ${createClasses('baseOilNumber')} _width_pc_12`}
        onClick={handleSortClick('baseOilNumber')}
      >
        <div>Base Oil No</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>
      <div
        className={`list-scene__table-header-element ${createClasses('baseFormulaBaseOilNumber')} _width_pc_12`}
        onClick={handleSortClick('baseFormulaBaseOilNumber')}
      >
        <div>Read Across Source</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>
      <div
        className={`list-scene__table-header-element ${createClasses('formulatorNumber')} _width_pc_18`}
        onClick={handleSortClick('formulatorNumber')}
      >
        <div>Formulation Number</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>
      <div
        className={`list-scene__table-header-element ${createClasses('isReadAcrossFormula')} _width_pc_12`}
        onClick={handleSortClick('isReadAcrossFormula')}
      >
        <div>Formulation Type</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>
      <div
        className={`list-scene__table-header-element ${createClasses('engineType')} _width_pc_10`}
        onClick={handleSortClick('engineType')}
      >
        <div>Engine Oil Type</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>
      <div
        className={`list-scene__table-header-element ${createClasses('applicationStatus')} _width_pc_12`}
        onClick={handleSortClick('applicationStatus')}
      >
        <div>Status</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>
      <div
        className={`list-scene__table-header-element ${createClasses('isPaid')} _width_pc_12`}
        onClick={handleSortClick('isPaid')}
      >
        <div>Fee status</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>
      <div className='list-scene__table-header-element  _width_pc_12' />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/formula/List/TableHeader.jsx